import React, { useCallback } from 'react'
import { Button, Dialog, Typography, useViewport, formatDate } from '@chilecompra/react-kit'
import { GridContainer, GridItem, RootContainer, ExclamationIcon } from './AddParticipantModal.styles'
import { useDispatch, useSelector } from 'react-redux'
import { onSetModalShowSuccess, onSendParticipantDataThunk } from './AddParticipantModal.actions'
import { onSetResetItemSelectedSuccess } from '../ManageParticipants/ManageParticipants.actions'
import { PUBLIC_URL } from '../../config/settings/environment'
import { useNavigate, useParams } from 'react-router-dom'
import { PATTERN_DATE } from '../../config/settings/constants'

/**
 * The Participant modal container.
 */
const AddParticipantModalContainer = () => {
  const navigate = useNavigate()
  const { processId, fromWhere } = useParams()
  const dispatch = useDispatch()
  const { participantId, externalCode } = useSelector(state => state.participantsList)
  const { showAddParticipantModal, loading } = useSelector(state => state.addParticipantModal)
  const {
    selectedFullName,
    selectedRole,
    selectedDni,
    selectedEmail,
    functionIdSelected,
    processIdSelected,
    process,
    functions,
    isForeignPerson,
    isOfficialOfInstitution,
    startDate,
    endDate
  } = useSelector(state => state.manageParticipants)
  const {
    authInfo: { orgCode }
  } = useSelector(state => state.authorizationProvider)

  const {
    size: { isDownToMedium }
  } = useViewport()

  const handleCloseModal = () => {
    dispatch(onSetModalShowSuccess({ showAddParticipantModal: false }))
  }

  const searchFunctionSelectedName = useCallback(() => {
    if (functionIdSelected && functions.length > 0) {
      const { name } = functions.find(item => item?.value === functionIdSelected)
      return name || ''
    }
    return ''
  }, [functionIdSelected, functions])

  const searchProcessSelectedName = useCallback(() => {
    if (processIdSelected && process.length > 0) {
      const { name } = process.find(item => item?.value === processIdSelected)
      return name || ''
    }
    return ''
  }, [processIdSelected, process])

  const processSelectedName = searchProcessSelectedName()
  const functionSelectedName = searchFunctionSelectedName()

  const handleGoParticipant = () => {
    navigate(`/participantes/${fromWhere}/${processId}`)
  }

  const handleCallbackExcecute = () => {
    dispatch(onSetResetItemSelectedSuccess())
  }

  const handleSubmit = () => {
    const payload = {
      selectedFullName,
      selectedRole,
      selectedDni,
      selectedEmail,
      functionIdSelected,
      processIdSelected,
      participantId,
      processId,
      isForeignPerson,
      isOfficialOfInstitution,
      orgCode: (externalCode && externalCode.split('-')[0]) || orgCode,
      onSuccessCallback: handleCallbackExcecute,
      handleGoParticipant,
      startDate,
      endDate
    }
    dispatch(onSendParticipantDataThunk(payload))
  }

  return (
    <Dialog
      open={showAddParticipantModal}
      onClose={handleCloseModal}
      margin="0 20px"
      padding="0px"
      maxWidth="750px"
      disableBackdropClick
    >
      <RootContainer justifyContent="center">
        <GridItem xs={12} container justifyContent="center">
          <ExclamationIcon src={`${PUBLIC_URL}/assets/images/alert_icon.svg`} />
        </GridItem>
        <GridItem xs={12} padding="37px 0 0">
          <Typography fontSize="18px" color="black1" fontWeight="bold" variant="h3" align="center">
            Incorporar participante al listado
          </Typography>
        </GridItem>
        <GridItem xs={12} md={8} padding="27px 0 0">
          <Typography
            fontSize={isDownToMedium ? '14px' : '16px'}
            color="black1"
            fontWeight="regular"
            variant="h3"
            align={isDownToMedium ? 'left' : 'center'}
          >
            Se agregará la siguiente persona al listado de participantes de este proceso de compra:
          </Typography>
        </GridItem>
        <GridItem container item xs={12} justifyContent="center">
          <GridItem
            xs={12}
            md={6}
            container
            justifyContent="left"
            padding={isDownToMedium ? '20px 0 0' : '40px 0 10px'}
          >
            <GridItem xs={12}>
              <Typography fontSize="14px" color="black1" fontWeight="bold" variant="h3" align="left">
                Participante
              </Typography>
            </GridItem>
            <GridItem xs={12}>
              <Typography fontSize="16px" color="black1" fontWeight="regular" variant="h3" align="left">
                {selectedFullName}
              </Typography>
            </GridItem>
          </GridItem>
          <GridItem
            xs={12}
            md={4}
            container
            justifyContent="left"
            padding={isDownToMedium ? '10px 0 0' : '40px 0 10px'}
          >
            <GridItem xs={12}>
              <Typography fontSize="14px" color="black1" fontWeight="bold" variant="h3" align="left">
                Cargo
              </Typography>
            </GridItem>
            <GridItem xs={12}>
              <Typography fontSize="16px" color="black1" fontWeight="regular" variant="h3" align="left">
                {selectedRole}
              </Typography>
            </GridItem>
          </GridItem>
          <GridItem xs={12} md={6} container justifyContent="left" padding={isDownToMedium ? '10px 0 0' : '10px 0'}>
            <GridItem xs={12}>
              <Typography fontSize="14px" color="black1" fontWeight="bold" variant="h3" align="left">
                RUT
              </Typography>
            </GridItem>
            <GridItem xs={12}>
              <Typography fontSize="16px" color="black1" fontWeight="regular" variant="h3" align="left">
                {selectedDni}
              </Typography>
            </GridItem>
          </GridItem>
          <GridItem xs={12} md={4} container justifyContent="left" padding={isDownToMedium ? '10px 0 0' : '10px 0'}>
            <GridItem xs={12}>
              <Typography fontSize="14px" color="black1" fontWeight="bold" variant="h3" align="left">
                Correo electrónico
              </Typography>
            </GridItem>
            <GridItem xs={12}>
              <Typography fontSize="16px" color="black1" fontWeight="regular" variant="h3" align="left">
                {selectedEmail}
              </Typography>
            </GridItem>
          </GridItem>
          <GridItem xs={12} md={6} container justifyContent="left" padding={isDownToMedium ? '10px 0 0' : '10px 0'}>
            <GridItem xs={12}>
              <Typography fontSize="14px" color="black1" fontWeight="bold" variant="h3" align="left">
                Etapa del proceso de compra
              </Typography>
            </GridItem>
            <GridItem xs={12}>
              <Typography fontSize="16px" color="black1" fontWeight="regular" variant="h3" align="left">
                {processSelectedName}
              </Typography>
            </GridItem>
          </GridItem>
          <GridItem xs={12} md={4} container justifyContent="left" padding={isDownToMedium ? '10px 0 0' : '10px 0'}>
            <GridItem xs={12}>
              <Typography fontSize="14px" color="black1" fontWeight="bold" variant="h3" align="left">
                Función
              </Typography>
            </GridItem>
            <GridItem xs={12}>
              <Typography fontSize="16px" color="black1" fontWeight="regular" variant="h3" align="left">
                {functionSelectedName}
              </Typography>
            </GridItem>
          </GridItem>
          <GridItem xs={12} md={6} container justifyContent="left" padding={isDownToMedium ? '10px 0 0' : '10px 0'}>
            <GridItem xs={12}>
              <Typography fontSize="14px" color="black1" fontWeight="bold" variant="h3" align="left">
                Fecha inicio de función
              </Typography>
            </GridItem>
            <GridItem xs={12}>
              <Typography fontSize="16px" color="black1" fontWeight="regular" variant="h3" align="left">
                {formatDate(startDate || new Date(), PATTERN_DATE)}
              </Typography>
            </GridItem>
          </GridItem>
          <GridItem xs={12} md={4} container justifyContent="left" padding={isDownToMedium ? '10px 0 0' : '10px 0'}>
            <GridItem xs={12}>
              <Typography fontSize="14px" color="black1" fontWeight="bold" variant="h3" align="left">
                Fecha fin de función
              </Typography>
            </GridItem>
            <GridItem xs={12}>
              <Typography fontSize="16px" color="black1" fontWeight="regular" variant="h3" align="left">
                {formatDate(endDate || new Date(), PATTERN_DATE)}
              </Typography>
            </GridItem>
          </GridItem>
        </GridItem>
        <GridItem xs={12} padding="48px 0 0">
          <GridContainer justifyContent="center">
            <GridItem xs={12} container justifyContent="center">
              <Button disabled={loading} loading={loading} onClick={handleSubmit} color="primary">
                Aceptar y continuar
              </Button>
            </GridItem>
            <GridItem xs={12} container justifyContent="center" padding="10px 0">
              <Button onClick={handleCloseModal} color="default" variant="text">
                Cancelar
              </Button>
            </GridItem>
          </GridContainer>
        </GridItem>
      </RootContainer>
    </Dialog>
  )
}

export default AddParticipantModalContainer
